import type { MagiaId } from '../data/magias';
import { ehMagiaPronta, MAGIAS } from '../data/magias';

/** Tabela da spec: MagiaId → arquivo em /sounds/skill/. Sem linha = mudo. */
const ARQUIVO: Partial<Record<MagiaId, string>> = {
  clumsy: 'clumsy.wav',
  'create-food': 'c_food.wav',
  feeblemind: 'feblmind.wav',
  heal: 'heal.wav',
  'magic-arrow': 'm_arrow.wav',
  'night-sight': 'birdseye.wav',
  'reactive-armor': 'protect.wav',
  weaken: 'weaken.wav',
  agility: 'agility.wav',
  cunning: 'cunning.wav',
  cure: 'cure.wav',
  harm: 'harm.wav',
  'magic-trap': 'trap.wav',
  'magic-untrap': 'untrap.wav',
  protection: 'protect.wav',
  strength: 'strength.wav',
  bless: 'bless.wav',
  fireball: 'magic_fyrbal01.wav',
  'magic-lock': 'm_lock.wav',
  poison: 'poison.wav',
  telekinesis: 'teleknes.wav',
  teleport: 'teleport.wav',
  unlock: 'unlock.wav',
  'wall-of-stone': 'walstone.wav',
  'arch-cure': 'archcure.wav',
  'arch-protection': 'aprotect.wav',
  curse: 'curse.wav',
  'greater-heal': 'gratheal.wav',
  lightning: 'thundr01.wav',
  'mana-drain': 'manadran.wav',
  recall: 'recall.wav',
  'blade-spirits': 'bladsprt.wav',
  'dispel-field': 'dispfild.wav',
  incognito: 'morph.wav',
  'magic-reflection': 'protect.wav',
  'mind-blast': 'mindblst.wav',
  paralyze: 'paralyze.wav',
  'poison-field': 'posnfild.wav',
  'summon-creature': 'sumncrtr.wav',
  dispel: 'massdisp.wav',
  'energy-bolt': 'nrgybolt.wav',
  explosion: 'explode.wav',
  invisibility: 'invisibl.wav',
  mark: 'mark.wav',
  'mass-curse': 'masscurs.wav',
  'paralyze-field': 'parafild.wav',
  reveal: 'reveal.wav',
  'chain-lightning': 'thundr01.wav',
  'energy-field': 'nergyfld.wav',
  flamestrike: 'flamstrk.wav',
  'gate-travel': 'gatetrvl.wav',
  'mana-vampire': 'manavamp.wav',
  'mass-dispel': 'massdisp.wav',
  'meteor-swarm': 'explode.wav',
  polymorph: 'morph.wav',
  earthquake: 'earthqke.wav',
  'energy-vortex': 'dethvrtx.wav',
  resurrection: 'resurect.wav',
  'summon-air-elemental': 'sumnelem.wav',
  'summon-daemon': 'sumndemn.wav',
  'summon-earth-elemental': 'sumnelem.wav',
  'summon-fire-elemental': 'sumnelem.wav',
  'summon-water-elemental': 'sumnelem.wav'
};

const EXTRA: Record<string, string> = {
  'guarda-chegada': 'teleport.wav',
  'guarda-raio': 'thundr01.wav'
};

export function arquivoDaMagia(spellId: string): string | undefined {
  return ARQUIVO[spellId as MagiaId] ?? EXTRA[spellId];
}

export function magiasDeDano(): MagiaId[] {
  return (Object.keys(MAGIAS) as MagiaId[]).filter(ehMagiaPronta);
}
